"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const helpers_1 = require("../helpers");
const theme_provider_1 = require("../theme-provider");
const ChevronDown = require("../../../volkswagen-onehub/icons-core/dist");
// NOTE: anim definition taken from CMS helpers
const ANIMATION_FUNCTION = '0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99)';
const StyledIcon = theme_provider_1.styled(ChevronDown.ChevronDown).withConfig({ displayName: "StyledIcon", componentId: "sc-10ubh8z" }) `
	color: ${props => props.theme.interaction.recipe450.default};
	transition: transform ${ANIMATION_FUNCTION};
	transform: ${props => (props.isOpen ? 'rotateX(180deg)' : 'rotateX(0)')};
	// To center icon vertically we need to calculate difference
	// between headline line height (headline300) and icon size (s200)
	margin-top: ${props => `calc((${props.theme.textAppearances.headline0300.lineHeight} - ${props.theme.size.static350}) / 2)`};
	transform-origin: 50% 50%;

	:hover {
		color: ${props => props.theme.interaction.recipe450.hover};
	}
`;
const StyledAccordion = theme_provider_1.styled.div.withConfig({ displayName: "StyledAccordion", componentId: "sc-cukd70" }) `
	border-bottom: solid 2px ${props => props.theme.border.color.secondary};
`;
const StyledAccordionHead = theme_provider_1.styled.button.withConfig({ displayName: "StyledAccordionHead", componentId: "sc-1qzivu4" }) `
	// NOTE: button reset
	padding: 0;
	border: 0;
	background: none;
	appearance: none;
	text-align: inherit;
	word-break: break-all;
	:lang(ko) {
		word-break: keep-all;
	}
	width: 100%;
	padding-top: ${props => props.theme.size.dynamic0100};
	padding-bottom: ${props => props.isOpen ? props.theme.size.dynamic0040 : props.theme.size.dynamic0100};

	@media (min-width: ${helpers_1.Breakpoints.desktop}px) {
		padding-bottom: ${props => props.theme.size.dynamic0050};
	}

	cursor: pointer;
	user-select: none;

	:focus {
		outline: none;

		${StyledIcon} {
			${props => helpers_1.createA11yOutlineStyles(props)}
		}
	}
`;
const StyledAccordionBody = theme_provider_1.styled.div.withConfig({ displayName: "StyledAccordionBody", componentId: "sc-1rp4zbl" }) `
	display: ${props => (props.isOpen ? 'grid' : 'none')};
	grid-template-columns: auto ${props => props.theme.size.grid001};
	padding-bottom: ${props => props.theme.size.dynamic0100};
`;
const StyledHeadWrapper = theme_provider_1.styled.div.withConfig({ displayName: "StyledHeadWrapper", componentId: "sc-bbl31t" }) `
	display: grid;
	grid-column-gap: ${props => props.theme.size.dynamic0100};
	grid-template-columns: auto max-content;
`;
exports.Accordion = props => {
    const { id, isOpen = false, headline, children, onClick } = props;
    const headId = id + '_head';
    const bodyId = id + '_body';
    return (React.createElement(StyledAccordion, { id: id },
        React.createElement(StyledAccordionHead, { id: headId, tabIndex: 0, isOpen: isOpen, onClick: onClick, "aria-expanded": isOpen, "aria-controls": bodyId },
            React.createElement(StyledHeadWrapper, null,
                headline,
                React.createElement(StyledIcon, { isOpen: isOpen, variant: "default" }))),
        React.createElement(StyledAccordionBody, { id: bodyId, isOpen: isOpen, "aria-hidden": !isOpen, "aria-labelledby": headId, role: "region" },
            React.createElement("div", null, children))));
};
exports.Accordion.displayName = 'Accordion';
